import Footer from '../components/Footer'
import Header from '../components/Header'

export default function Home() {
    return <>
    <Header />
    <div className = "home">
        <div className='home-image-start-section'>
            <img className="image-logo" src={require("../images/logo.png")} />
            <img src={require("../images/24Stunden.png")} />
        </div>

        <h1>Herzlich Willkommen</h1>

        <div>
            <p>
                Auf dieser Seite finden Sie eine kurze Übersicht zu meinen Leistungen, 
                sowie einen kleinen Ausschnitt von Artikeln, die ich liefern kann.
            </p>

            <p>
                Die gesamte Produktpalette umfasst mehr als 10.000 bestellbare Artikel. 
                Fordern Sie daher meinen aktuellen Katalog an. 
                Gerne berate ich Sie auch telefonisch oder per E-Mail.
            </p>
        </div>

        <div className="icon-flexbox">  
            <div className="icon-section">
                <img className='icon' src={require("../images/icon-phone-call.png")} />
                <h2>
                    Kompetente Beratung
                </h2>
                
                Kompetente Beratung mit vielen Jahren Erfahrung im Handel mit Büroartikeln.
            </div>

            <div className="icon-section">
                <img className='icon' src={require("../images/icon-smile.png")} />
                <h2>
                    Zufriedene Kunden
                </h2>

                Zufriedene Kunden sind mein oberstes Ziel.

            </div>

            <div className="icon-section">
                <img className='icon' src={require("../images/icon-time.png")} />
                <h2>
                    24h Service
                </h2>
            
                Rund um die Uhr für Sie erreichbar. Bestellen Sie Ihre Ware noch heute.

            </div>

        </div>

        <h1>Mein Markenzeichen</h1>

        <div>
            <p>
                Ich verkaufe alles rund ums Büro: Tinte, Toner, Papier, Büroartikel, Hygieneartikel
                und Schulbedarf. 
            </p>

            <p>
                Seit vielen Jahren stehe ich einem festen Kundenstamm in Bad Oeynhausen
                und in den Kreisen Minden-Lübbecke und Herford kompetent zur Seite.
            </p>

            <p>
                Lieferung persönlich und kostenfrei direkt ins Büro oder zu Ihnen nach Hause. 
                Bei weiteren Fragen sprechen Sie mich gerne an!
            </p>
        </div>
    </div>    

    <Footer />
    </>
}